import { Testimonial, Service } from "@/lib/types";

// Services data
export const services: Service[] = [
  {
    id: "bookkeeping",
    title: "Bookkeeping",
    icon: "fas fa-book-open",
    description: "Accurate and timely recording of financial transactions to keep your business on track.",
    longDescription: "Our comprehensive bookkeeping services ensure your financial records are accurate, up-to-date, and compliant with standards. We handle transaction recording, account reconciliation, and financial statement preparation.",
    benefits: [
      "Accurate financial records",
      "Time-saving automation",
      "Error reduction",
      "Better financial visibility",
      "Simplified tax preparation",
      "Regulatory compliance"
    ]
  },
  {
    id: "bookkeeping-cleanup",
    title: "Bookkeeping Cleanup",
    icon: "fas fa-broom",
    description: "Professional reconciliation and correction of financial records to resolve discrepancies.",
    longDescription: "Our bookkeeping cleanup services correct and organize your financial records to ensure accuracy. We identify and fix discrepancies, update transaction categorizations, and bring your books into compliance.",
    benefits: [
      "Corrected historical records",
      "Account reconciliation",
      "Error identification and resolution",
      "Properly categorized transactions",
      "Organized financial documentation",
      "Audit-ready financial statements"
    ]
  },
  {
    id: "financial-statements",
    title: "Financial Statements",
    icon: "fas fa-file-alt",
    description: "Comprehensive financial reports that provide insights for informed business decisions.",
    longDescription: "We prepare accurate and professional financial statements including balance sheets, income statements, and cash flow statements that give you clear visibility into your business's financial position.",
    benefits: [
      "Professional presentation for stakeholders",
      "Clear financial position overview",
      "Performance trend analysis",
      "Decision-making support",
      "Regulatory compliance",
      "Investor and banking relationship management"
    ]
  },
  {
    id: "audit",
    title: "Auditing",
    icon: "fas fa-search-dollar",
    description: "Detailed examination of financial records to identify discrepancies and ensure accuracy.",
    longDescription: "Our thorough auditing services help verify the accuracy of your financial information, identify potential issues, and ensure your records meet compliance standards. We provide detailed reviews with actionable recommendations.",
    benefits: [
      "Error identification",
      "Fraud prevention",
      "Process improvement",
      "Compliance verification",
      "Risk assessment",
      "Control enhancement"
    ]
  },
  {
    id: "payroll",
    title: "Payroll & Taxes",
    icon: "fas fa-money-bill-wave",
    description: "Streamlined payroll processing and tax management to ensure compliance and accuracy.",
    longDescription: "Our comprehensive payroll and tax services handle the complex aspects of employee compensation and tax obligations. We manage everything from calculating wages and withholdings to filing required tax forms.",
    benefits: [
      "Accurate and timely payments",
      "Tax compliance",
      "Direct deposit options",
      "Detailed reporting",
      "Employee portal access",
      "Reduced administrative burden"
    ]
  },
  {
    id: "llc-services",
    title: "LLC Creation & Maintenance",
    icon: "fas fa-building",
    description: "Complete assistance with forming and maintaining your Limited Liability Company.",
    longDescription: "We guide you through the entire process of establishing your LLC and help you maintain it properly. Our services include filing formation documents, setting up compliance calendars, and managing ongoing requirements.",
    benefits: [
      "Proper legal formation",
      "Compliance with state requirements",
      "Annual report filings",
      "Record keeping assistance",
      "Operating agreement development",
      "Tax election advisory"
    ]
  },
  {
    id: "sales-tax",
    title: "Sales Tax",
    icon: "fas fa-percentage",
    description: "Expert handling of sales tax obligations to ensure compliance and avoid penalties.",
    longDescription: "Navigate the complexities of sales tax with our expert filing services. We handle collection tracking, form preparation, timely submissions, and ensure you remain compliant with changing regulations.",
    benefits: [
      "Multi-state compliance",
      "Deadline management",
      "Audit risk reduction",
      "Rate and rule updates",
      "Historical filing corrections",
      "Exemption certificate management"
    ]
  },
  {
    id: "hr",
    title: "Human Resources",
    icon: "fas fa-users",
    description: "Comprehensive HR assistance to help you manage your team effectively and compliantly.",
    longDescription: "Our HR support services help you manage your workforce efficiently while maintaining compliance with employment regulations. We assist with onboarding, benefits administration, and policy development.",
    benefits: [
      "Regulatory compliance",
      "Employee documentation",
      "Benefits administration",
      "Onboarding assistance",
      "Policy development",
      "Performance management systems"
    ]
  },
  {
    id: "consulting",
    title: "Consulting",
    icon: "fas fa-comments",
    description: "Strategic financial advice to optimize your business operations and growth potential.",
    longDescription: "Our consulting services provide expert guidance on financial strategy, business optimization, and growth planning. We analyze your unique situation to deliver tailored recommendations and solutions.",
    benefits: [
      "Objective expert perspective",
      "Customized strategic planning",
      "Problem identification and resolution",
      "Process improvement",
      "Growth opportunity analysis",
      "Risk management strategies"
    ]
  },
  {
    id: "financial-officer",
    title: "Expert Financial Officer",
    icon: "fas fa-user-tie",
    description: "Professional financial management and strategy without the cost of a full-time CFO.",
    longDescription: "Our financial officer services provide executive-level financial expertise on a fractional basis. We help with financial planning, analysis, risk management, and strategic decision-making.",
    benefits: [
      "Executive financial expertise",
      "Strategic planning",
      "Cost-effective solution",
      "Objective financial analysis",
      "Improved financial controls",
      "Stakeholder reporting"
    ]
  },
  {
    id: "accounts-payable",
    title: "Accounts Payable",
    icon: "fas fa-file-invoice",
    description: "Efficient management of your company's payment obligations to vendors and suppliers.",
    longDescription: "Our accounts payable services ensure your business pays its obligations accurately and on time. We implement efficient systems for invoice processing, payment approvals, and vendor management.",
    benefits: [
      "Streamlined payment processes",
      "Vendor relationship management",
      "Cash flow optimization",
      "Duplicate payment prevention",
      "Timely payment discounts capture",
      "Detailed expense tracking"
    ]
  },
  {
    id: "accounts-receivable",
    title: "Accounts Receivable",
    icon: "fas fa-hand-holding-usd",
    description: "Effective management of client payments to improve cash flow and reduce outstanding balances.",
    longDescription: "Our accounts receivable services optimize your collection processes to improve cash flow and reduce payment delays. We implement efficient invoicing systems, follow-up procedures, and client payment tracking.",
    benefits: [
      "Improved cash flow",
      "Reduced outstanding balances",
      "Automated invoicing systems",
      "Structured follow-up processes",
      "Clear payment tracking",
      "Client payment portal options"
    ]
  },
  {
    id: "quickbooks",
    title: "QuickBooks Setup",
    icon: "fas fa-laptop-code",
    description: "Expert QuickBooks configuration and optimization tailored to your business needs.",
    longDescription: "As certified QuickBooks ProAdvisors, we provide comprehensive setup, training, and optimization of your QuickBooks accounting system. We configure it to match your specific business requirements and workflows.",
    benefits: [
      "Customized chart of accounts",
      "Workflow optimization",
      "Data migration assistance",
      "User training",
      "Integration with other systems",
      "Ongoing technical support"
    ]
  }
];

// Testimonials data
export const testimonials: Testimonial[] = [
  {
    id: 1,
    name: "Jennifer Stickler",
    company: "Mountain Luxury",
    quote: "Sarah transformed our financial operations. Her QuickBooks expertise and attention to detail have saved us countless hours and provided clarity we never had before.",
    rating: 5,
    image: "https://images.unsplash.com/photo-1438761681033-6461ffad8d80?ixlib=rb-1.2.1&auto=format&fit=crop&w=200&h=200&q=80",
    date: "January 15, 2023"
  },
  {
    id: 2,
    name: "Mark Rinehart",
    company: "Attorney",
    quote: "As a law professional, I need precise financial records. Sarah delivers exceptional accuracy and has been instrumental in organizing our firm's finances.",
    rating: 5,
    image: "https://images.unsplash.com/photo-1472099645785-5658abf4ff4e?ixlib=rb-1.2.1&auto=format&fit=crop&w=200&h=200&q=80",
    date: "March 22, 2023"
  },
  {
    id: 3,
    name: "Steele Whiting",
    company: "Steele Workings",
    quote: "Sarah's payroll services have been a game-changer for our small manufacturing business. Her expertise saves us time and ensures our compliance.",
    rating: 4.5,
    image: "https://images.unsplash.com/photo-1566492031773-4f4e44671857?ixlib=rb-1.2.1&auto=format&fit=crop&w=200&h=200&q=80",
    date: "May 10, 2023"
  },
  {
    id: 4,
    name: "Robert Fowers",
    company: "First Fire Protection",
    quote: "Working with Sarah has given us financial clarity and confidence. Her strategic guidance has helped us grow our business while maintaining strong financial health.",
    rating: 5,
    image: "https://images.unsplash.com/photo-1545167622-3a6ac756afa4?ixlib=rb-1.2.1&auto=format&fit=crop&w=200&h=200&q=80",
    date: "August 5, 2023"
  }
];

// Chatbot responses - moved to use-chatbot.tsx hook

// Sample data for dashboard and client portal (for demo purposes)
export const sampleClients = [
  { id: 1, name: "Mountain Luxury", email: "info@mountainluxury.com", phone: "801-555-1234", company: "Mountain Luxury LLC", status: "active" },
  { id: 2, name: "Mark Rinehart", email: "mark@rinehartlaw.com", phone: "801-555-2345", company: "Rinehart Law Firm", status: "active" },
  { id: 3, name: "Steele Whiting", email: "steele@steeleworkings.com", phone: "801-555-3456", company: "Steele Workings Inc.", status: "active" },
  { id: 4, name: "Robert Fowers", email: "rfowers@firstfire.com", phone: "801-555-4567", company: "First Fire Protection", status: "active" }
];

export const sampleTasks = [
  { 
    id: 1, 
    clientId: 1, 
    title: "Review Q3 Financial Statements", 
    description: "Review and verify third quarter financial statements for accuracy and compliance.",
    dueDate: "2023-10-15",
    priority: "high",
    completed: false,
    progress: 25
  },
  { 
    id: 2, 
    clientId: 2, 
    title: "Payroll Tax Filing", 
    description: "Prepare and submit quarterly payroll tax filings for Rinehart Law Firm.",
    dueDate: "2023-10-20",
    priority: "medium",
    completed: false,
    progress: 50
  },
  { 
    id: 3, 
    clientId: 3, 
    title: "QuickBooks Training", 
    description: "Schedule and conduct QuickBooks training session for new accounting staff.",
    dueDate: "2023-10-25",
    priority: "low",
    completed: true,
    progress: 100
  },
  { 
    id: 4, 
    clientId: 4, 
    title: "Annual Budget Planning", 
    description: "Assist with creating annual budget projections for next fiscal year.",
    dueDate: "2023-11-01",
    priority: "medium",
    completed: false,
    progress: 10
  }
];

export const sampleInvoices = [
  {
    id: 1,
    clientId: 1,
    invoiceNumber: "INV-2023-001",
    amount: 1250.00,
    issueDate: "2023-09-01",
    dueDate: "2023-09-30",
    status: "paid",
    pdfUrl: "#",
    paymentUrl: "#"
  },
  {
    id: 2,
    clientId: 2,
    invoiceNumber: "INV-2023-002",
    amount: 950.00,
    issueDate: "2023-09-15",
    dueDate: "2023-10-15",
    status: "pending",
    pdfUrl: "#",
    paymentUrl: "#"
  },
  {
    id: 3,
    clientId: 3,
    invoiceNumber: "INV-2023-003",
    amount: 750.00,
    issueDate: "2023-09-30",
    dueDate: "2023-10-30",
    status: "pending",
    pdfUrl: "#",
    paymentUrl: "#"
  },
  {
    id: 4,
    clientId: 4,
    invoiceNumber: "INV-2023-004",
    amount: 1500.00,
    issueDate: "2023-10-01",
    dueDate: "2023-10-31",
    status: "pending",
    pdfUrl: "#",
    paymentUrl: "#"
  }
];

export const sampleDocuments = [
  {
    id: 1,
    clientId: 1,
    name: "Q2 Financial Report.pdf",
    description: "Quarterly financial statements",
    uploadedAt: "2023-07-15",
    type: "pdf",
    size: "1.2 MB",
    url: "#"
  },
  {
    id: 2,
    clientId: 2,
    name: "Employee Handbook.docx",
    description: "Updated employee handbook",
    uploadedAt: "2023-08-10",
    type: "doc",
    size: "825 KB",
    url: "#"
  },
  {
    id: 3,
    clientId: 3,
    name: "Inventory Analysis.xlsx",
    description: "Quarterly inventory review",
    uploadedAt: "2023-09-05",
    type: "xls",
    size: "950 KB",
    url: "#"
  },
  {
    id: 4,
    clientId: 4,
    name: "Tax Documents 2023.pdf",
    description: "Business tax filings",
    uploadedAt: "2023-04-12",
    type: "pdf",
    size: "2.4 MB",
    url: "#"
  }
];

export const sampleMessages = [
  {
    id: 1,
    clientId: 1,
    content: "Hi Sarah, could you review our latest financial projections and provide feedback?",
    timestamp: "2023-10-01T14:30:00",
    fromClient: true,
    read: true
  },
  {
    id: 2,
    clientId: 1,
    content: "I've looked at the projections and have a few suggestions. Let's schedule a call to discuss the details.",
    timestamp: "2023-10-01T15:45:00",
    fromClient: false,
    read: true
  },
  {
    id: 3,
    clientId: 2,
    content: "We need to update our payroll system. When can we discuss options?",
    timestamp: "2023-10-02T10:15:00",
    fromClient: true,
    read: false
  },
  {
    id: 4,
    clientId: 3,
    content: "I've uploaded our latest inventory data. Could you update our financial forecast?",
    timestamp: "2023-10-03T09:30:00",
    fromClient: true,
    read: false
  }
];
